// extracted by mini-css-extract-plugin
export default {"titleBar":"RootView_titleBar__UJf0J","title":"RootView_title__0MTKt","button":"RootView_button__62XyF","buttonDiv":"RootView_buttonDiv__BFpHx"};